import { GetterTree } from 'vuex'
import { TriggeredActionState } from '@/store/triggeredActions/index'
import { RootState } from '@/store'

export const getters: GetterTree<TriggeredActionState, RootState> = {
    requestParams(state: TriggeredActionState): any {
        const params = {
            pagination: true,
            page: state.page,
            itemsPerPage: state.itemsPerPage,
            active: state.activeFilter,
            company: state.companyFilter,
            name: state.nameFilter,
        }

        if (state.orderField && state.orderDirection) {
            params[`order[${state.orderField}]`] = state.orderDirection
        }

        return params
    },
}
